import { put, takeLatest, delay } from "redux-saga/effects";
import { getLoyaltyDetailApi } from "store/api/SpecialOfferApi";
import { GET_LOYALTY_DETAIL_ACTION } from "../../actions/SpecialOfferPageAction/actionTypes";

import * as specialOfferPageAction from "../../actions/SpecialOfferPageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getLoyaltyDetail(action) {
	yield put(globalAction.openLoadingPage());
	const res = yield getLoyaltyDetailApi(action.params);
	try {
		if (res?.code === 0) {
			yield put(specialOfferPageAction.setLoyaltyDetailAction(res?.data));
		} else {
			yield errorMessage(res?.message);
		}
		yield delay(500);
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* getLoyaltyDetailSaga() {
	yield takeLatest(GET_LOYALTY_DETAIL_ACTION, getLoyaltyDetail);
}

export default getLoyaltyDetailSaga;
